import { Outlet } from "react-router-dom";

const WasteManagementReportLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default WasteManagementReportLayout;
